<input [(ngModel)]='searchTerm'>
